var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAvatarDetectiveMan = function SvgAvatarDetectiveMan(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.826,9.464a5.253,5.253,0,0,0,.14-1.211V6.691"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.466,6.7V8.253A5.253,5.253,0,0,0,9.5,13.361"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.966,6.691a8.273,8.273,0,0,1-5.25,1.96A8.287,8.287,0,0,1,5.466,6.7a8.268,8.268,0,0,1,5.25-1.964A8.275,8.275,0,0,1,15.966,6.691Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.486,17.669A9.75,9.75,0,0,1,20.129,23.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.209,23.16A9.74,9.74,0,0,1,5.251,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.466,6.7C5.466,3.4,7.817.84,10.716.84s5.25,2.556,5.25,5.851"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.716,
    y1: 0.84,
    x2: 10.716,
    y2: 4.732
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.113,11.96h6.346a1,1,0,0,0,1-1v-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "16.486 17.669 17.959 15.46 12.959 15.46 10.959 17.21 8.959 15.46 3.959 15.46 5.251 17.398"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.959,
    cy: 20.654,
    r: 0.375
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.459,7.523V6.84c0-1.242.531-2.22,1.561-2.22a1.62,1.62,0,0,0,1.771-1.48c0-.846-.663-1.348-1.772-1.348H18.642c-.714,0-1.163-.4-1.163-.952"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarDetectiveMan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "avatar-detective-man.f4fda6803a1f4c495894b263952789fb.svg";